;(function ($) {

    $(document).ready(function(){
  
        ageVerification();
  
    });
  
    //functions
    function ageVerification(){
        //check for cookie
        if ( !Cookies.get('ageVerified') ) {
            $("#ageverify").fadeIn(500, function() {
                $(this).show();
                $(this).addClass('add-color');
                $('#ageverify .age-logo').show("slide", { direction: "up" }, 500);
                $('#ageverify .bottom-white-angle').show("slide", { direction: "down" }, 500);
                $('#ageverify .age-options').addClass('reveal');
            }); 
        } 

        $('#verify-me').click(function(e){
            e.preventDefault();
            Cookies.set('ageVerified', 'true', { expires: 30 });
            $('#ageverify .age-options').removeClass('reveal');
            $('#ageverify .bottom-white-angle').hide("slide", { direction: "down" }, 500);
            $('#ageverify .age-logo').hide("slide", { direction: "up" }, 500);
            $('#ageverify').removeClass('add-color');
            $("#ageverify").fadeOut(500, function() {
                $(this).hide()
            });           
        });
    }
  
  })(jQuery);
  